import React from 'react';
import { ZoneId } from '@teetsh/app/src/types/zone';
import Select from '@teetsh/app/src/components/Form/Select2';
import { zoneOptions } from './zoneOptions';
import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

interface Props {
  onChange: (v: ZoneId) => void;
  value?: ZoneId;
  extraLarge?: boolean;
  large?: boolean;
  withWhiteBg?: boolean;
}

export function ZoneSelector(props: Props) {
  const { onChange, value, withWhiteBg } = props;
  const { t } = useTranslation(['zone']);
  return (
    <Select<ZoneId>
      options={zoneOptions.map(z => ({
        ...z,
        label: t(`zone:zoneList.${z.value}`),
      }))}
      data-testid="zone-button-selector"
      value={value}
      large={props.large}
      css={[withWhiteBg && tw`bg-white`]}
      extralarge={props.extraLarge}
      label={t('zone:zoneLabel')}
      onChange={onChange}
    />
  );
}
